<mat-toolbar class="site-nav" color="primary" role="navigation" aria-label="Primary">
  <a class="brand" routerLink="/" aria-label="Go to Home">
    <span class="logo-mark" aria-hidden="true"></span>
    <span class="site-title">Project Brendan</span>
  </a>

  <span class="spacer"></span>

  <a mat-button routerLink="/about" routerLinkActive="active-link">About</a>

  <app-theme-picker></app-theme-picker>
</mat-toolbar>

